import $, { each } from "jquery";
export function contact() {
  //ラジオボタンが選択されたら、クラスを振り直す
  $('.radio__item input').click(function(){
    $('.radio__item').each(function(){
      $(this).removeClass('is-active');
    })
    $(this).parent('label').addClass('is-active');
  });

  //selectボタンのselectedを変更
  $('.select').change(function(){
    $(this).find('select').addClass('is-select');
    $(this).children().click(function(){
      $(this).prop('selected',true);
    });
  });

  //emailの形式をチェック
  const email_check =()=>{
    //メールアドレス
    if($('#js-mail').parents('.form__item').hasClass('is-error')){
      //必須項目で弾かれていた場合は何もしない
    }
    else{
      if ($("#js-mail").val().match(/^[A-Za-z0-9][A-Za-z0-9_.-]*@[A-Za-z0-9_.-]+\.[A-Za-z0-9]+$/) == null){
        //メールアドレスの形式が正しくない場合
        $("#js-mail").parents('.form__item').addClass('is-error');
        $("#js-mail").parents('.form__item').find('.is-error__inaccurate').addClass('is-error');
        flg_validation = false;
      }
      else{
        //メールアドレスの形式が正しい場合
        $("#js-mail").parents('.form__item').removeClass('is-error');
        $("#js-mail").parents('.form__item').find('.is-error__inaccurate').removeClass('is-error');
      }
    }
    //確認用メール
    if($('#js-mail_confirmation').parents('.form__item').hasClass('is-error')){
      //必須項目で弾かれていた場合は何もしない
    }
    else{
      if ($("#js-mail_confirmation").val().match(/^[A-Za-z0-9][A-Za-z0-9_.-]*@[A-Za-z0-9_.-]+\.[A-Za-z0-9]+$/) == null){
        //メールアドレスの形式が正しくない場合
        $("#js-mail_confirmation").parents('.form__item').addClass('is-error');
        $("#js-mail_confirmation").parents('.form__item').find('.is-error__inaccurate').addClass('is-error');
        flg_validation = false;
      }
      else{
        //メールアドレスの形式が正しい場合
        $("#js-mail_confirmation").parents('.form__item').removeClass('is-error');
        $("#js-mail_confirmation").parents('.form__item').find('.is-error__inaccurate').removeClass('is-error');

        //メールアドレスの不一致チェック
        if($("#js-mail_confirmation").val() && $("#js-mail").val() != $('#js-mail_confirmation').val()){
          $("#js-mail").parents('.form__item').addClass('is-error');
          $("#js-mail_confirmation").parents('.form__item').addClass('is-error');
          $("#js-mail").parents('.form__item').find('.is-error__mismatch').addClass('is-error');
          $("#js-mail_confirmation").parents('.form__item').find('.is-error__mismatch').addClass('is-error');
          flg_validation = false;
        }
        else{
          $("#js-mail").parents('.form__item').removeClass('is-error');
          $("#js-mail_confirmation").parents('.form__item').removeClass('is-error');
          $("#js-mail").parents('.form__item').find('.is-error__mismatch').removeClass('is-error');
          $("#js-mail_confirmation").parents('.form__item').find('.is-error__mismatch').removeClass('is-error');
        }
      }
    }
  };

  //電話番号のチェック
  const tel_check = ()=>{
    if($('.submit_item.tel').parents('.form__item').hasClass('is-error')){
      //必須項目で弾かれていたら何もしない
    }
    else{
      const tel_value = $('input.tel').val();
      const reg_exp = /[\d|\+|\-|\.|\)|\)]{10,20}/;
      if(tel_value.match(reg_exp) != null){
        //電話番号の形式が正しい場合
        $('.submit_item.tel').parents('.form__item').removeClass('is-error');
        $('.submit_item.tel').parents('.form__item').find('.is-error__inaccurate').removeClass('is-error');
      }
      else{
        //電話番号の形式が正しくない場合
        flg_validation = false;
        $('.submit_item.tel').parents('.form__item').addClass('is-error');
        $('.submit_item.tel').parents('.form__item').find('.is-error__inaccurate').addClass('is-error');
      }
    };
  }

  let flg_validation;
  $('#form__btn').click(function(){
    const arr_formItem = [];
    const arr_mandatory = [];
    const length = $('.form__item').length;
    let item_val;
    let roop_dom;
    for(let i = 1 , len = length; i <= len; i++){
      roop_dom = $('.form__item:nth-child(' + i + ')');
      if($('.form__item:nth-child(' + i + ')').hasClass('radio')){
        //ラジオボタンの場合
        item_val = $('.form__item:nth-child(' + i + ')').find('.is-active').children('input').val();
      }
      else if($('.form__item:nth-child(' + i + ')').hasClass('textarea')){
        //textareaボタンの場合
        item_val = $('.form__item:nth-child(' + i + ')').find('textarea').val();
      }
      else{
        item_val = $('.form__item:nth-child(' + i + ') .submit_item').val();
      }
      if($('.form__item:nth-child(' + i + ')').children('dt').children('span').hasClass('is-mandatory')){
        arr_mandatory.push('mandatory');
      }
      else{
        arr_mandatory.push('no-mandatory');
      }
      arr_formItem.push(item_val);
    }
    //必須項目のチェックとis-errorのつけ外し
    flg_validation = true;
    for(let key in arr_mandatory){
      if(arr_mandatory[key] == 'mandatory'){
        //必須項目の場合
        if(arr_formItem[key] == '' || arr_formItem[key] == undefined){
          $('.form__item').eq(key).find('.is-error__required').addClass('is-error');
          $('.form__item').eq(key).addClass('is-error');
          flg_validation = false;
        }
        else{
          $('.form__item').eq(key).find('.is-error__required').removeClass('is-error');
          $('.form__item').eq(key).removeClass('is-error');
        }
      }
    }
    email_check();
    tel_check();
    $('#js-modal').click(function(){
      $('#js-modal').removeClass('is-active');
    });
    $('#js-modal').children('.c-inner').click(function(e){
      e.stopPropagation();
    })
    if(flg_validation){
      $('#js-modal').addClass('is-active');
      $('#js-modal__close').click(function(){
        $('#js-modal').removeClass('is-active');
      });

      /*
        modalのhtmlを作成する
      */
      $('#modal__inner').children('dl').remove();
      let add_html = '<dl>';
      for(let key in arr_formItem ){
        if($('#js-form .form__item').eq(key).hasClass('modal_skip')){
        }
        else{
          let add_html_ttl =$('#js-form .form__item').eq(key).find('dt').find('span').html();
          add_html += `
              <div class="form__item__modal">
                <dt>${add_html_ttl}</dt>
                <dd>${arr_formItem[key]}</dd>
              </div>`;
        }
      }
      add_html += '</dl>'
      $('#modal__inner').append(add_html);
    }
    else{
    }
  })
  $("#js-contact-btn__submit").on("click", function (e) {
    $("#js-form").submit();
  });
}